import { ITenderDashboardData } from 'types/tender/tenderDashboard'
import { Doughnut } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { useTranslation } from 'react-i18next'

ChartJS.register(ArcElement, Tooltip, Legend)

type Props = {
  dashboardData: ITenderDashboardData
}

export const DashboardChart = ({ dashboardData }: Props) => {
  const { t } = useTranslation()
  const data = {
    labels: [
      t('future-contests'),
      t('ongoing-contests'),
      t('winner-selected-contests'),
    ],
    datasets: [
      {
        label: t('count'),
        data: [
          dashboardData.planningTenderCount,
          dashboardData.ongoingTenderCount,
          dashboardData.completedTenderCount,
        ],
        backgroundColor: ['#a8e3c9', '#eec978', '#796cf9'],
        borderWidth: 1,
      },
    ],
  }

  const options = {
    plugins: {
      legend: {
        position: 'bottom' as const,
      },
    },
  }

  return <Doughnut data={data} options={options} />
}
